var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('Portal', {
    attrs: {
      "to": "layout"
    }
  }, [_vm.value ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: {
        handler: _setup.onClickOutside,
        include: _setup.getInclude
      },
      expression: "{ handler: onClickOutside, include: getInclude }"
    }],
    class: _vm.contentClass,
    staticStyle: {
      "position": "fixed",
      "z-index": "1300"
    },
    style: _setup.contentStyle
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };